import { CalendarFold, ChevronLeft, ChevronRight, TriangleAlert } from 'lucide-react'
import DatePicker from 'react-datepicker'
import classNames from 'classnames'

import Label from '@/elements/Label'

import 'react-datepicker/dist/react-datepicker.css'
import './FormDatePicker.scss'

interface FormDatePickerProps {
  name: string
  value?: Date | null
  onChange?: (date: Date | null) => void
  placeholder?: string
  label?: string
  disabled?: boolean
  dirty?: boolean
  error?: string
  maxDate?: Date | null
}

const FormDatePicker = ({
  name,
  value,
  onChange,
  placeholder,
  label,
  disabled,
  dirty,
  error,
  maxDate
}: FormDatePickerProps) => {
  return (
    <div className='form-field date-picker'>
      <Label htmlFor={name} hidden={!label}>{label}</Label>
      <DatePicker
        id={name}
        selected={value}
        onChange={(date: Date | null) => onChange?.(date)}
        placeholderText={placeholder}
        className={classNames('date-picker-input', { dirty })}
        showMonthDropdown
        showYearDropdown
        showIcon
        icon={<CalendarFold />}
        showPopperArrow={false}
        previousMonthButtonLabel={<ChevronLeft />}
        nextMonthButtonLabel={<ChevronRight />}
        disabled={disabled}
        autoComplete='off'
        maxDate={maxDate ?? undefined}
      />
      {error && (
        <span className='field-error'>
          <TriangleAlert size={12} />
          {error}
        </span>
      )}
    </div>

  )
}

export default FormDatePicker
